<template>
	<v-container fluid grid-list-xl class="py-5 px-5">
		<v-flex xs12 md12>
			<v-layout wrap row>
				<v-flex
					xs12
					md4
					v-for="(report, index) in reports"
					:key="index"
				>
					<Link
						as="v-card"
						color="white"
						:href="$route(report.to, $page.props.tenant.id)"
						:key="report.title"
					>
						<v-list-item two-line>
							<v-list-item-content>
								<v-list-item-title class="headline">
									{{ report.title }}
								</v-list-item-title>
								<v-list-item-subtitle>
									{{ report.title }}
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
						<v-divider></v-divider>

						<v-card-text style="text-align: center">
							<v-icon size="90">{{ report.icon }}</v-icon>
						</v-card-text>
					</Link>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-container>
</template>

<script>
import TenantLayout from "../../../layouts/tenant.vue";
import TenantReportLayout from "../../../layouts/partials/tenant/report.vue";
import { Link } from "@inertiajs/inertia-vue";
export default {
	layout: [TenantLayout, TenantReportLayout],
	components: {
		Link,
	},
	data() {
		return {
			reports: [
				{
					icon: "mdi-chart-areaspline",
					title: this.$t("title.daily"),
					to: "tenant.reports.daily",
				},

				{
					icon: "mdi-cash-usd",
					title: this.$t("title.monthly"),
					to: "tenant.reports.monthly",
				},
				{
					icon: "mdi-home-variant-outline",
					title: this.$t("title.outlet"),
					to: "tenant.reports.outlet",
				},

				{
					icon: "mdi-chart-areaspline-variant",
					title: this.$t("title.chart"),
					to: "tenant.reports.chart",
				},
			],
		};
	},
};
</script>
